import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Content from './Content'

const ExpensesV2Settings = () => {
  const content = <Content />

  return <ResponsivePage.Body>{content}</ResponsivePage.Body>
}

export default ExpensesV2Settings
